import { FormattedMessage } from "react-intl";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Row, Col, Button } from "reactstrap/lib";

export default function APLInformationPersonInfoModal({
  aplInfoPerson,
  toggleInfoPersonOpen,
  infoPersonOpen,
}) {
  return (
    <Modal isOpen={infoPersonOpen} toggle={toggleInfoPersonOpen}>
      <ModalHeader toggle={toggleInfoPersonOpen}>
        {aplInfoPerson.name}
      </ModalHeader>
      <ModalBody>
        <Col>
          <Row>
            <Col lg={3}>
              <label>
                <FormattedMessage id="PhoneNumber" />:
              </label>
              <br />
              <label>
                <FormattedMessage id="Email" />:
              </label>
            </Col>
            <Col>
              <label>{aplInfoPerson.phoneNumber}&nbsp;</label>
              <br />
              <label>{aplInfoPerson.mail}</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <label style={{ borderBottom: "1px solid lightgrey" }}>
                <FormattedMessage id="PersonsConnectedToInfoPerson" />
              </label>
              {aplInfoPerson.forUsers &&
                aplInfoPerson.forUsers.map((user) => {
                  return (
                    <div key={user.id}>
                      {user.value ? user.value.name : user.name}
                    </div>
                  );
                })}
            </Col>
          </Row>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggleInfoPersonOpen}>
          <FormattedMessage id="Close" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
